import React from "react";
import "./PrivacyPolicy.scss";

function PrivacyPolicy({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="privacy-modal-overlay" onClick={onClose}>
      <div
        className="privacy-modal-content"
        onClick={(e) => e.stopPropagation()} // Prevent closing on modal click
      >
        <button className="close-modal" onClick={onClose}>
          &times;
        </button>
        <h1>Privacy Policy</h1>
        <p>
          Effective Date: <strong>2nd December, 2024</strong>
        </p>

        {/* Privacy Policy Content */}
        <section className="privacy-modal-section">
          <h2>1. Information We Collect</h2>
          <p>We may collect the following types of information:</p>
          <ul>
            <li>
              <strong>Personal Information:</strong> If you contact us, we may
              collect your name, email address, or other details you provide.
            </li>
            <li>
              <strong>Non-Personal Information:</strong> This includes data such
              as your IP address, browser type, and pages visited, collected
              through analytics tools.
            </li>
          </ul>
        </section>

        <section className="privacy-modal-section">
          <h2>2. How We Use Your Information</h2>
          <p>The information we collect may be used to:</p>
          <ul>
            <li>Improve the content and design of our website.</li>
            <li>Respond to your inquiries or feedback.</li>
            <li>Monitor website performance and usage trends.</li>
          </ul>
        </section>

        <section className="privacy-modal-section">
          <h2>3. Third-Party Services</h2>
          <p>
            We may use third-party tools like Google Analytics or social media
            plugins. These services may collect information about your visit,
            including your IP address. We recommend reviewing the privacy
            policies of these third-party services for more details.
          </p>
        </section>

        <section className="privacy-modal-section">
          <h2>4. External Links</h2>
          <p>
            Our website may contain links to external websites. We are not
            responsible for the privacy practices or content of those sites.
            Please review their privacy policies before providing personal
            information.
          </p>
        </section>

        <section className="privacy-modal-section">
          <h2>5. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Request corrections or deletion of your personal data.</li>
          </ul>
          <p>
            For any such requests, please contact us at{" "}
            <a href="mailto:tldrblogs@gmail.com">tldrblogs@gmail.com</a>.
          </p>
        </section>

        <section className="privacy-modal-section">
          <h2>6. Updates to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Changes will be
            posted on this page, and the effective date will be updated
            accordingly.
          </p>
        </section>

        <section className="privacy-modal-section">
          <h2>7. Contact Us</h2>
          <p>
            If you have any questions or concerns about this Privacy Policy,
            feel free to contact us at:
          </p>
          <ul>
            <li>
              Email:{" "}
              <a href="mailto:tldrblogs@gmail.com">tldrblogs@gmail.com</a>
            </li>
            <li>
              Instagram:{" "}
              <a
                href="https://instagram.com/tldrblogs"
                target="_blank"
                rel="noopener noreferrer"
              >
                @tldrblogs
              </a>
            </li>
            <li>
              Pinterest:{" "}
              <a
                href="https://www.pinterest.com/tldrblogs/_created"
                target="_blank"
                rel="noopener noreferrer"
              >
                tldrblogs
              </a>
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
